import { SubmitAttachment } from '../models/mercury-form';

// Fallback when the browser cannot tell the file's MIME type.
export const DEFAULT_ATTACHMENT_CONTENT_TYPE = 'application/octet-stream';

// File → `requestDetails.attachments[]` entry for POST /offeringFulfillmentRequest.
export function toSubmitAttachment(file: File): Promise<SubmitAttachment> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // readAsDataURL yields "data:<type>;base64,<data>"; the API wants only <data>.
      const dataUrl = String(reader.result ?? '');
      resolve({
        name: file.name,
        contentType: file.type || DEFAULT_ATTACHMENT_CONTENT_TYPE,
        data: dataUrl.slice(dataUrl.indexOf(',') + 1),
      });
    };
    reader.onerror = () => reject(reader.error ?? new Error(`Could not read ${file.name}`));
    reader.readAsDataURL(file);
  });
}
